import { createAction } from 'redux-actions'
import yoyi from 'src/helpers/fetch/fetchService'
import token from 'src/helpers/tokenService'
import { ydmpApi } from 'src/utils/path'
import { message } from 'antd'
import history from 'src/helpers/history'
import { appRootPath } from 'src/_funcSwitch'
import { isNil } from 'lodash'

export const RECEIVE_OFFLINE_LIST = 'RECEIVE_OFFLINE_LIST'
export const SAVE_CHECK_THE_NUMBER_REQ = 'SAVE_CHECK_THE_NUMBER_REQ'
export const RECEIVE_SEARCH_VAL = 'RECEIVE_SEARCH_VAL'
export const RECEIVE_PREVIEW_LIST = 'RECEIVE_PREVIEW_LIST'
export const RECEIVE_BATCH_UPLOAD = 'RECEIVE_BATCH_UPLOAD'
export const RECEIVE_ACTIVE_NUMBER_ALL = 'RECEIVE_ACTIVE_NUMBER_ALL'
export const RECEIVE_ACTIVE_NUMBER = 'RECEIVE_ACTIVE_NUMBER'

export const receiveOfflineList = createAction(RECEIVE_OFFLINE_LIST)
export const saveCheckTheNumberReq = createAction(SAVE_CHECK_THE_NUMBER_REQ)
export const receiveSearchVal = createAction(RECEIVE_SEARCH_VAL)
export const receivePreviewList = createAction(RECEIVE_PREVIEW_LIST)
export const receiveBatchUpload = createAction(RECEIVE_BATCH_UPLOAD)
export const receiveActiveNumberAll = createAction(RECEIVE_ACTIVE_NUMBER_ALL)
export const receiveActiveNumber = createAction(RECEIVE_ACTIVE_NUMBER)

// lbs离线列表
// export const fetchOfflineList = (payload, body) => async (dispatch) => {
//     try {
//         const baseUrl = 'lbsCircle/list'
//         const url = effectiveObject(payload) ? formatGet(baseUrl, payload) : baseUrl
//         const response = await yoyi.post(url, body)

//         dispatch(receiveOfflineList(response))
//     } catch (e) {
//         yoyi.exceptionMessage(e)
//     }
// }

// export const checkTheNumber = payload => async (dispatch) => {
//     try {
//         await yoyi.post(`/LBSCircle/insert`, payload)
//         dispatch(saveCheckTheNumberReq(payload))
//         history.push(`${appRootPath}/crowdManage/lbsCircle/0`)
//     } catch (e) {
//         yoyi.exceptionMessage(e)
//     }
// }

// 操作
export interface IUpdateOperatingPayload {
  id: number
  operating: number
}
// export const updateOperating = (payload: IUpdateOperatingPayload) => async () => {
//     try {
//         await yoyi.post(`LBSCircle/updateOperating`, payload)
//         history.push(`${appRootPath}/crowdManage/lbsCircle/0`)
//     } catch (e) {
//         yoyi.exceptionMessage(e)
//     }
// }

// 存储搜索词
// export const setSearchVal = (payload: string) => async (dispatch) => {
//     try {
//         dispatch(receiveSearchVal(payload))
//     } catch (e) {
//         yoyi.exceptionMessage(e)
//     }
// }

// 下载
export interface IDownloadFilePayload {
  id: number,
  fileName: string,
  circleType: number
}
export const downloadFile = (payload: IDownloadFilePayload) => async () => {
  try {
    const requestHeaders = {
      headers: {
        token: token.get() as any
      },
      method: 'GET',
      credentials: 'include',
    }
    const url = `${ydmpApi}/circle/download?circleId=${payload.id}&fileName=${payload.fileName}&circleType=${payload.circleType}`
    fetch(url, requestHeaders as any).then(res => {
      if (res.status == 200) {
        location.href = url
      } else {
        yoyi.exceptionMessage(res)
      }
    })
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

export const clearPreviewList = payload => async (dispatch) => {
  try {
    dispatch(receivePreviewList([]))
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

// 预览文件
export interface IPreviewFilePayload {
  id: number
}
export const previewFile = (payload: IPreviewFilePayload) => async (dispatch) => {
  try {
    let response = await yoyi.get(`lbsOffline/preview`, payload) as any
    response.shift()
    dispatch(receivePreviewList(response))
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

// 批量上传
export const batchUpload = payload => async (dispatch) => {
  try {
    const response = await yoyi.postFile(`lbsCircle/uploadFile`, payload)
    dispatch(receiveBatchUpload(response))
    message.success('LBS文件创建成功，定位人群正在计算中...')
    history.push(`${appRootPath}/crowdManage/lbsCircle/0`)
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

// 创建lbs人群
export const createLbsCrowd = payload => async (dispatch) => {
  try {
    await yoyi.post(`lbsCircle/save`, payload)
    message.success('LBS文件创建成功，定位人群正在计算中...')
    history.push(`${appRootPath}/crowdManage/lbsCircle/0`)
  } catch (e) {
    yoyi.exceptionMessage(e)
  }
}

// export const clearActiveNumberAll = payload => async (dispatch) => {
//     try {
//         dispatch(receiveActiveNumberAll(0))
//     } catch (e) {
//         yoyi.exceptionMessage(e)
//     }
// }

// export const getActiveNumber = payload => async (dispatch) => {
//     try {
//         const { lat, lng, name } = payload
//         const response = await yoyi.get(`/lbsCircle/getActiveNumber`, { lat, lng })
//         dispatch(receiveActiveNumber({ name, response }))
//     } catch (e) {
//         yoyi.exceptionMessage(e)
//     }
// }
//// old
//// ------------------------
//// new 
import { ActionType } from './type'
import { lbsActiveNumber } from 'src/api/crowdManage'


export const updateStateAction = createAction(ActionType.UPDATE_STATE)
export const updateState = params => dispatch => dispatch(updateStateAction(params))
export const PAGE_SIZE = 50

export const resetSearchResult = () => dispatch => {
  dispatch(updateStateAction({
    searchResult: {
      cityList: [],
      list: [],
      total: 0,
      current: 0,
      pageSize: PAGE_SIZE
    }
  }))
}

export const bMapLocalSearch = () => {
  return (dispatch, stateGetter) => {

    const BMap: any = (window as any).BMap
    if (!BMap) return

    const state = stateGetter().lbsCircle
    const city = state.searchCurrentCity
    const keyWord = state.searchKeyWord
    let localSearchInstance: any = null
    // console.log('local search action', city, keyWord)

    dispatch(updateStateAction({ searchLoading: true }))

    return new Promise((resolve, reject) => {
      localSearchInstance = new BMap.LocalSearch(city, {
        renderOptions: { autoViewport: true },
        pageCapacity: PAGE_SIZE,
        onSearchComplete: (results) => {

          console.log('baidu search result', results)
          if (isNil(results)) {
            dispatch(updateStateAction({ searchLoading: false }))
            return
          }

          // // resolve(results)

          results.total = results.getNumPois() // results.ZA
          results.pageSize = PAGE_SIZE
          results.current = results.getPageIndex() // results.tT
          results.cityList = results.getCityList() || [] // results.AQ

          const resultsLength = results.getCurrentNumPois()
          results.list = Array.from({ length: resultsLength })
          .map((_, i) => results.getPoi(i))

          // 获取每个点的预估人数
          if (Array.isArray(results.list)) {
            Promise.all(results.list.map(({ point: { lng, lat } }) => {
              return lbsActiveNumber({ lat, lng })
            }))
              .then(res => {
                const predictMap = state.searchPointPredict ? new Map(state.searchPointPredict) : new Map()
                // console.log('current page predict number', res)
                res.forEach((pointNumber: number, currIndex: number) => {
                  predictMap.set(currIndex + results.current * PAGE_SIZE, pointNumber)
                })

                dispatch(updateStateAction({ searchPointPredict: predictMap }))
              })
          }


          dispatch(updateStateAction({
            searchResult: results,
            // localSearchInstance,
            searchLoading: false,
            searchCurrentCity: results.city
          }))
        }
      })

      window['LbsLocalSearchInstance'] = localSearchInstance

      localSearchInstance.search(keyWord)

      resolve(localSearchInstance)
    })
  }
}